/** Shell port: access to the main content host (e.g. layout `#main`). */
export interface ShellLayoutPort {
  getMainContentHost(): Promise<HTMLElement | null>;
}

/** `#main` inside `layout-component` (shadow DOM). */
export class DomShellLayoutAdapter implements ShellLayoutPort {
  async getMainContentHost(): Promise<HTMLElement | null> {
    let layoutComponent = document.querySelector('layout-component');

    if (!layoutComponent) {
      layoutComponent = await this.waitForLayoutComponent();
      if (!layoutComponent) return null;
    }

    let main = this.getMainFromLayout(layoutComponent);

    if (!main) {
      const startTime = Date.now();
      const timeout = 3000;
      while (!main && Date.now() - startTime < timeout) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        main = this.getMainFromLayout(layoutComponent);
      }
    }

    return main;
  }

  private getMainFromLayout(layoutComponent: Element): HTMLElement | null {
    if (!(layoutComponent instanceof HTMLElement)) return null;
    const shadowRoot = layoutComponent.shadowRoot;
    if (!shadowRoot) return null;
    return shadowRoot.getElementById('main');
  }

  private waitForLayoutComponent(timeout: number = 2000): Promise<Element | null> {
    return new Promise((resolve) => {
      const startTime = Date.now();
      const checkLayout = () => {
        const layout = document.querySelector('layout-component');
        if (layout?.shadowRoot) {
          resolve(layout);
        } else if (Date.now() - startTime < timeout) {
          setTimeout(checkLayout, 10);
        } else {
          resolve(null);
        }
      };
      checkLayout();
    });
  }
}
